import { useEffect } from 'react';
import useLocalStorage from '../../../../utils/services/localStorage/useLocalStorage';

import { CHECKOUT_NAVIGATION_STACK } from '../checkoutConstants';

const MAX_NAVIGATION_STACK_SIZE = 5;

const useCheckoutNavigationStack = (location: { pathname: string }): string[] => {
    const [navigationStack, setNavigationStack] = useLocalStorage<string[]>(CHECKOUT_NAVIGATION_STACK, []);

    // each time the location changes, add the new path to the navigation stack
    const pathName = location.pathname;
    useEffect(() => {
        if (pathName !== navigationStack[0]) {
            setNavigationStack((stack) => [pathName, ...stack].slice(0, MAX_NAVIGATION_STACK_SIZE));
        }
    }, [pathName]);

    // on unmount, clear the navigation stack
    useEffect(() => {
        return () => {
            setNavigationStack([]);
        };
    }, []);

    return navigationStack;
};

export default useCheckoutNavigationStack;
